import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { ModuleService } from '../_services/dispo/module.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private moduleService: ModuleService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')) {
      try {
        const user = JSON.parse(localStorage.getItem('currentUser') as string);
        const hasDispoAccess = !!(user?.access_dispo_portal ?? user?.accessDispoPortal);
        if (!hasDispoAccess) {
          localStorage.removeItem('currentUser');
          localStorage.removeItem('remember');
          this.router.navigate(['/login'], { queryParams: { error: 'no_dispo_access' } });
          return false;
        }
      } catch {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('remember');
        this.router.navigate(['/login']);
        return false;
      }
      // Logged in so return true
      this.moduleService.module_id = null;
      return true;
    }

    // Not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
